// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"295":"b7439787","331":"b7439787","476":"b7439787","629":"b7439787","776":"b7439787"}[chunkId] + ".chunk.css";
};